export const SET_USER_LOGS = 'SET_USER_LOGS'
export const RESET_USER_LOGS = 'RESET_USER_LOGS'
